import styled from 'styled-components';

const Description = styled.p`
  margin-top: 30px;
  margin-bottom: 12px;
  color: var(--text-text-600, #232b3a);
  text-align: center;

  /* Body/Body 2 - Regular */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.028px;
`;

export default Description;
